import {useState, useEffect} from 'react';
import Loader from '../../Tools/Loader';
import { Alert } from '@mui/material';
import API from '../../../services/API';
import moment from 'moment';
import PiSignatureForm from '../../Dpc/PiSignatureForm';
import { Lock } from '@mui/icons-material';

export default function Participation({id}){

    const [reg, setReg] = useState(null)

    const [status, setStatus] = useState('loading')

    useEffect(() => {

        API.get(`/dpc/registrations/${id}`)
            .then(({data}) => {

                setReg(data)

                const isEnded = moment().valueOf() > moment(data.session?.end + 'T00:00:00').valueOf();

                if( !isEnded ) {

                    setStatus('locked')

                } else if( data.participationDoc ) {

                    setStatus('success')
                
                }else {

                    setStatus('ready')
                }

            })
            .catch(_ => setStatus('error'))

    }, [id]);


    if(status === 'loading') return <Loader />

    if(status === 'error') return <Error />

    if(status === 'locked') return <Locked until={reg?.session?.end} />

    if(status === 'expired') return <Expired />

    return <PiSignatureForm id={id} />
}


function Locked({until}){

    return <Alert severity='info' icon={<Lock/>}>
        Votre attestation sera débloquée à la fin de votre session DPC, le {moment(until).format('DD/MM/YYYY')}.
    </Alert>
}

function Expired(){

    return <Alert severity='info' icon={<Lock/>}>
        Votre attestation n'est plus disponible.
    </Alert>
}


function Error(){

    return <Alert severity='error'>Une erreur s'est produite.</Alert>
}